var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"woocommerce-order"},[_c('h2',{staticClass:"woocommerce-notice notice-warning-msg"},[_vm._v(" "+_vm._s(_vm.$t('checkoutDeclined'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }